// extracted by mini-css-extract-plugin
module.exports =  {"submitBtn":"submitBtn___Y7VkA","spinner":"spinner___uozNW"};